import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import ImageCarousel from './Carousel.js'
import { FaFacebook, FaYoutube } from 'react-icons/fa';
import { FaArrowRightLong } from 'react-icons/fa6';
import AmbuSeva_Patient_Tnc from "./pages/Patient_TnC.jsx";
import AmbuSeva_Partner_Tnc from "./pages/Partner_TnC.jsx";
import AmbuSeva_Privacy_Policy from "./pages/Privacy_Policy.jsx";

// Single-file React + Tailwind static website for a temple
// Default export is App component — drop into a Create React App / Vite project.

const rituals = [
  { id: 1, name: 'Mangal Aarti', time: '04:30 AM / 05:30 AM', description: 'Morning aarti with traditional hymns.' },
  { id: 2, name: 'Nitya Puja', time: '08:00 AM', description: 'Ritualistic worship performed daily.' },
  { id: 3, name: 'Bhog Aarti', time: '12:30 PM', description: 'Bhog nivedan and aarti.' },
  { id: 4, name: 'Sandhya Aarti', time: '05:45 PM / 06:30 PM', description: 'Evening aarti with bhajan and kirtan.' },
];

const recentEvents = [
  { id: 1, title: 'Saraswati Puja 2026', date: '23rd Jan 2026', summary: 'Special Puja, Vaidik Yagya, Spiritual Discourses and Cultural Programs.' },
  { id: 2, title: 'Sri Sri Maa Sarada Devi\'s 173rd Janmatithi Utsav', date: '11th Dec 2025 — 15th Dec 2025', summary: 'Special Puja, Spiritual Discourses by Sanyasis and Cultural Programs.' },
  { id: 3, title: 'Sri Sri Jagaddhatri Puja', date: '31st Oct 2025 — 4th Nov 2025', summary: 'Ritualistic pooja, cultural programs and free prasad seva for all at Ramakrishnapuram Ashram.' },
  { id: 4, title: 'Dipanwita Amavasya Kali Puja', date: '20th Oct 2025', summary: 'Special pooja and cultural programs.' },
  { id: 5, title: 'Sri Sri Sarodiya Durga Puja', date: '27th Sep 2025 — 2nd Oct 2025', summary: 'Ritualistic Durga Puja at kalyani ashram and free prasad seva for everyone.' },
];

const upcomingEvents = [
  { id: 1, title: 'Sri Sri Thakur Ramakrishna Paramhamsa Dev\'s 191st Janmatithi Utsav', date: '19th Feb 2026 — 21st Feb 2026', summary: 'Special Puja, Mahasnan/Abhishek, Homa(Fire Ritual), Spiritual Discourses by Sanyasis and Cultural Programs.' },
];

const philanthropy = [
  { id: 1, title: 'Seva towards Special Children', location: "Ramakrishnapuram (Saheb Bagan)", year: 2025, details: "We provide fully furnished, affordable residential flats for specially-abled and autistic children and their families, along with nutritious meals and trained caregivers. Children receive continuous care in the absence of parents and lifelong support even after parents pass away, ensuring a secure future and well-being." },
  { id: 2, title: 'Pashupati Drug Center', location: "Kalyani", year: 2024, details: 'Affordable life-saving generic medicines for common people who cannot afford costly drugs.' },
  { id: 3, title: 'Ambulance Service', location: "Kalyani", year: 2006, details: 'Affordable, State of the Art ICU Ambulances with trained drivers and Swarg-Raths are provided for all emergencies.' },
  { id: 4, title: 'Old-Age Home', location: "Ramakrishnapuram (Saheb Bagan)", year: 2019, details: 'Our old age home provides fully furnished flats with geyser, TV, fridge and amenities, plus four daily meals and trained caregivers, all for ₹100 per day, ensuring comfort, dignity and support for senior citizens who do not have anyone to look after them.' },
  { id: 5, title: 'Residential Hostel', location: "Kalyani", year: 2005, details: 'Free residential hostel for meritorious but needy students from financially weak families.' },
  { id: 6, title: 'Pallimangal', location: "Kalyani", year: 2010, details: 'Daily household items, incense sticks, edible items, divine photos at low price.' },
  { id: 7, title: 'Milk and Paneer Counter', location: "Kalyani", year: 2006, details: 'Pure cow milk and paneer at affordable rates. No adulteration.' },
  { id: 8, title: 'Milk and Paneer Home Delivery', location: "Kalyani", year: 2010, details: 'Affordable pure cow milk and paneer delivered straight to your home.' },
];

function Container({ children }) {
  return <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">{children}</div>;
}

function Header() {
  return (
    <header className="bg-gradient-to-br from-yellow-100 to-yellow-200 shadow-md sticky top-0 z-50">
      <Container>
        <div className="flex items-center justify-between h-1/5 rounded-lg">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-20 h-20 rounded-full bg-transparent flex items-center justify-center">
              <img src={ require('./assets/images/mmom_logo_no_bg.png') } alt='Logo'/>
            </div>
            <div>
              <h1 className="text-pretty font-semibold">Matri Mission 'O' Mandir</h1>
              <p className="text-xs text-gray-500 font-medium">Sree Sree Adya Mandir</p>
            </div>
          </Link>
          <nav className="hidden md:flex gap-6 items-center">
            <NavLink to="/">Home</NavLink>
            <NavLink to="/rituals">Rituals</NavLink>
            <NavLink to="/events">Events</NavLink>
            <NavLink to="/seva">Seva</NavLink>
            <NavLink to="/about">About</NavLink>
            <NavLink to="/contact">Contact Us</NavLink>
          </nav>
          <MobileMenu />
        </div>
      </Container>
    </header>
  );
}

function NavLink({ to, children }) {
  return (
    <Link to={to} className="text-gray-700 hover:text-orange-600 font-medium">
      {children}
    </Link>
  );
}

function MobileMenu() {
  const [open, setOpen] = React.useState(false);
  return (
    <div className="md:hidden">
      <button onClick={() => setOpen(v => !v)} className="p-2 rounded-md focus:outline-none">
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
      {open && (
        <div className="absolute right-4 mt-2 w-48 bg-white border rounded shadow-lg py-2">
          <MobileLink to="/" onClick={() => setOpen(false)}>Home</MobileLink>
          <MobileLink to="/rituals" onClick={() => setOpen(false)}>Rituals</MobileLink>
          <MobileLink to="/events" onClick={() => setOpen(false)}>Events</MobileLink>
          <MobileLink to="/seva" onClick={() => setOpen(false)}>Seva</MobileLink>
          <MobileLink to="/about" onClick={() => setOpen(false)}>About</MobileLink>
          <MobileLink to="/contact" onClick={() => setOpen(false)}>Contact</MobileLink>
        </div>
      )}
    </div>
  );
}

function MobileLink({ to, children, onClick }) {
  return (
    <Link to={to} onClick={onClick} className="block px-4 py-2 text-gray-700 hover:bg-gray-50">{children}</Link>
  );
}

function Footer() {
  return (
    <footer className="bg-gradient-to-b from-gray-50 to-gray-200 shadow-sm border-t mt-12 py-8">
      <Container>
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div>
            <h3 className="font-semibold">Matri Mission 'O' Mandir</h3>
            <h3 className="text-xs text-gray-500 font-medium mb-1">Sree Sree Adya Mandir</h3>
            <p className="text-xs text-gray-500 font-normal">A-9/155, Kalyani, West Bengal, India, 741235.</p>
            <a href='https://maps.app.goo.gl/dpLesqe83wQpkBbeA' className='font-semibold text-xs text-blue-700 underline'>Locate us on Google Maps</a>
          </div>
          <div className="text-sm text-gray-600">© {new Date().getFullYear()} Matri Mission 'O' Mandir — All rights reserved</div>
        </div>
      </Container>
    </footer>
  );
}

function Home() {
  return (
    <main className="py-12">
      <Container>
        <motion.section initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
          <div className="rounded-2xl overflow-hidden grid grid-cols-1 md:grid-cols-2 gap-8 items-center bg-gradient-to-br from-white to-orange-50 p-8 shadow">
            <div>
              <h2 className="text-lg font-semibold mb-0">Welcome to</h2>
              <h2 className="text-2xl font-bold mb-3">Matri Mission 'O' Mandir</h2>
              <p className="text-gray-700 mb-4 italic">Awakening the divine within through devotion, disciplined spiritual life and selfless service for the welfare of all.</p>
              <div className="flex gap-3 mt-10 mb-10">
                <Link to="/events" className="px-4 py-2 bg-orange-500 text-white rounded shadow">Events</Link>
                <Link to="/seva" className="px-4 py-2 border border-orange-200 rounded">Seva</Link>
              </div>
            </div>
            {/* <div className="h-110 bg-gray-100 rounded-xl items-center relative justify-center">
              <ImageCarousel/>
            </div> */}
            {/* 🔥 Replaced Placeholder with Carousel */}
            <div className="w-full">
              <ImageCarousel />
            </div>
          </div>
        </motion.section>

        <section className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          <NavLink to="/events">
            <Card title="Upcoming Event" subtitle={upcomingEvents[0].title}/>
          </NavLink>
          <NavLink to="https://www.facebook.com/mmomkalyani/">
            <Card title={
              <div className='flex flex-row items-stretch justify-between gap-4 mb-4'>
                <FaFacebook size={45} color='blue' />
                <FaArrowRightLong size={20} color='grey' className='mt-2' />
              </div>
            } subtitle="Visit our Facebook Page"/>
          </NavLink>
          <NavLink to="https://www.youtube.com/@sanga-prasanga">
            <Card title= {
              <div className='flex flex-row items-stretch justify-between gap-4 mb-4'>
                {<FaYoutube size={45} color='red' />}
                <FaArrowRightLong size={20} color='grey' className='mt-2' />
              </div>
            } subtitle="Visit our YouTube Channel (Sanga-Prasanga)"/>
          </NavLink>
        </section>

      </Container>
    </main>
  );
}

function Card({ title, subtitle }) {
  return (
    <div className="h-full p-6 bg-white rounded-lg shadow">
      <h4 className="font-semibold">{title}</h4>
      <p className="text-sm text-gray-600 mt-2">{subtitle}</p>
    </div>
  );
}

function Rituals() {
  return (
    <main className="py-12">
      <Container>
        <h2 className="text-2xl font-bold mb-4">Daily Pooja Timings</h2>
        <div className="grid gap-4">
          {rituals.map(r => (
            <div key={r.id} className="p-4 bg-white rounded-lg shadow flex justify-between items-center">
              <div>
                <h3 className="font-semibold">{r.name}</h3>
                <p className="text-sm text-gray-600">{r.description}</p>
              </div>
              <div className="text-sm text-orange-600 font-medium">{r.time}</div>
            </div>
          ))}
        </div>
      </Container>
    </main>
  );
}

function Events() {
  return (
    <main className="py-12">
      <Container>
        <h2 className="text-2xl font-bold mb-4">Upcoming Events</h2>
        <div className="space-y-4 mb-10">
          {upcomingEvents.map(ev => (
            <article key={ev.id} className="p-4 bg-white rounded-lg shadow">
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="font-semibold">{ev.title}</h3>
                  <p className="text-sm text-gray-600">{ev.summary}</p>
                </div>
                <time className="text-sm text-gray-500">{ev.date}</time>
              </div>
            </article>
          ))}
        </div>
      </Container>
      <Container>
        <h2 className="text-2xl font-bold mb-4">Recent Events</h2>
        <div className="space-y-4">
          {recentEvents.map(ev => (
            <article key={ev.id} className="p-4 bg-white rounded-lg shadow">
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="font-semibold">{ev.title}</h3>
                  <p className="text-sm text-gray-600">{ev.summary}</p>
                </div>
                <time className="text-sm text-gray-500">{ev.date}</time>
              </div>
            </article>
          ))}
        </div>
      </Container>
    </main>
  );
}

function Philanthropy() {
  return (
    <main className="py-12">
      <Container>
        <h2 className="text-2xl font-bold mb-4">Service to Society</h2>
        <div className="grid gap-4">
          {philanthropy.map(p => (
            <div key={p.id} className="p-4 bg-white rounded-lg shadow">
              <h3 className="font-semibold">{p.title} <span className="text-sm text-gray-500">(Since {p.year})</span></h3>
              <p className="text-sm text-gray-600 mt-2">{p.details}</p>
              <p className="text-sm font-semibold text-orange-500 mt-2">Location: {p.location}</p>
            </div>
          ))}
        </div>
      </Container>
    </main>
  );
}

function About() {
  return (
    <main className="py-12">
      <Container>
        <h2 className="text-2xl font-bold mb-4">About Matri Mission 'O' Mandir</h2>
        <div className="prose max-w-none text-gray-700">
          <p className='font-normal text-gray-800'>
            Matri Mission ‘O’ Mandir is a Sannyasi-led spiritual institution founded in the year 2000, dedicated to the ideal of self-realisation through devotion, service and renunciation. Guided by the divine grace of Maa Adya Kali and the sacred guru parampara of Thakur Sri Ramakrishna Paramahamsa, our mandir stands as a sanctuary for seekers striving for spiritual purity, inner awakening, and heartfelt devotion. 
            The presence of spiritually advanced sanyasis and brahmacharis preserves an atmosphere of discipline, serenity, and deep spiritual introspection.
            Our main shrine houses Sri Sri Adya Maa, the revered form of Goddess Kali, due to which the temple is also lovingly known as Adya Mandir.
            Daily puja and bhog aarati are offered to the deities grounding devotees in devotion and divine presence.
            Throughout the year, our mandir celebrates sacred festivals such as Rathayatra, Durga Puja, Kali Puja, and Annapurna Puja, drawing numerous devotees who come to experience the Mother’s blessings.
            The Birth Anniversary of Sri Sri Maa Sarada Devi is observed as our Annual Festival, radiating spiritual joy and upliftment.
            Aligned with our spiritual mission, we also undertake various philanthropic services to support the well-being of society, embodying the spirit of selfless service.
          </p>
          <br/>
          <p className='font-semibold text-gray-500'>
            Our motto is to attain god through devotion, selfless service and renunciation.
          </p>
        </div>
      </Container>
      <Container>
        <h2 className="text-2xl font-bold mt-10 mb-4">Our Branches</h2>
        <div className="prose max-w-none text-gray-700">
          <p className='text-gray-700 font-semibold text-sm mb-4'>We have 2 official branches</p>
          <a href='https://maps.app.goo.gl/dpLesqe83wQpkBbeA' className='font-semibold text-sm text-blue-700 underline'>Matri Mission 'O' Mandir, Kalyani</a>
          <br/>
          <a href='https://maps.app.goo.gl/2KaoZ89fbqYffp9b8' className='font-semibold text-sm text-blue-700 underline'>Matri Mission 'O' Mandir, Ramakrishnapuram (Saheb Bagan)</a>
        </div>
      </Container>
    </main>
  );
}

function Contact() {
  const [form, setForm] = React.useState({ name: '', email: '', message: '' });
  return (
    <main className="py-12">
      <Container>
        <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
        <div className="grid md:grid-cols-2 gap-6">
          <form className="space-y-4 bg-white p-6 rounded-lg shadow" onSubmit={(e) => e.preventDefault()}>
            <div>
              <label className="block text-sm font-medium mb-1">Name</label>
              <input value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full border rounded px-3 py-2" placeholder="Your name" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Email</label>
              <input value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="w-full border rounded px-3 py-2" placeholder="you@example.com" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Message</label>
              <textarea value={form.message} onChange={e => setForm({...form, message: e.target.value})} className="w-full border rounded px-3 py-2 h-32" placeholder="How can we help?" />
            </div>
            <div>
              <button type="submit" className="px-4 py-2 bg-orange-500 text-white rounded">Send Message</button>
            </div>
          </form>

          <aside className="bg-white p-6 rounded-lg shadow">
            <h3 className="font-semibold">Matri Mission 'O' Mandir</h3>
            <h3 className="text-xs text-gray-500 font-medium mb-1">Sree Sree Adya Mandir</h3>
            <p className="text-xs text-gray-500 font-normal mb-1">A-9/155, Kalyani, West Bengal, India, 741235.</p>
            <div className="prose max-w-none text-gray-700 mb-8">
              <a href='https://maps.app.goo.gl/dpLesqe83wQpkBbeA' className='font-semibold text-xs text-blue-700 underline'>Matri Mission 'O' Mandir, Kalyani</a>
              <br/>
              <a href='https://maps.app.goo.gl/2KaoZ89fbqYffp9b8' className='font-semibold text-xs text-blue-700 underline'>Matri Mission 'O' Mandir, Ramakrishnapuram (Saheb Bagan)</a>
            </div>
            <div className="mt-5">
              <h5 className="font-semibold mb-1">Daily Visiting Hours</h5>
              <p className="text-xs text-gray-500 font-medium mb-1">Morning: 6:30 AM — 12:30 PM</p>
              <p className="text-xs text-gray-500 font-medium mb-1">Evening: 4:30 PM — 9:00 PM</p>
            </div>
            <br/>

            <p className="text-sm text-gray-600 row-auto font-semibold mt-1 mb-1">
              Phone: <a href='tel:+917059428773' className='font-semibold text-sm text-blue-700 underline'>+91 70594 28773</a>
            </p>
            
            <p className="text-sm font-semibold text-gray-600">
              Email: <a href='mailto:matrimission@gmail.com' className='font-semibold text-sm text-blue-700 underline'>matrimission@gmail.com</a>
            </p>
          </aside>
        </div>
      </Container>
    </main>
  );
}

function MainLayout({ children }) {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
}


export default function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50 text-gray-900">
        <Routes>
          <Route path="/ambuseva_patient_tnc" element={<AmbuSeva_Patient_Tnc />} />
          <Route path="/ambuseva_partner_tnc" element={<AmbuSeva_Partner_Tnc />} />
          <Route path="/ambuseva_privacy_policy" element={<AmbuSeva_Privacy_Policy />} />
          <Route path="/" element={<MainLayout><Home /></MainLayout>}/>
          <Route path="/rituals" element={<MainLayout><Rituals /></MainLayout>}/>
          <Route path="/events" element={<MainLayout><Events /></MainLayout>}/>
          <Route path="/seva" element={<MainLayout><Philanthropy /></MainLayout>}/>
          <Route path="/about" element={<MainLayout><About /></MainLayout>}/>
          <Route path="/contact" element={<MainLayout><Contact /></MainLayout>}/>
        </Routes>
      </div>
    </Router>
  );
}

//todo branches
// link with github and deploy to clouflare
